import {
    useCallback,
} from 'react'
import csvToJson from 'app/utils/csvToJson'
import useLabel from 'app/hooks/useLabel'

type Props = {
    onLoadData: (data: Record<string, any>[], file: File) => void
    setError: (error: string | null) => void

}

const useParseCsvFile = ({
    onLoadData,
    setError,
}: Readonly<Props>) => {
    const l = useLabel()

    return useCallback((file: File) => {
        if (file.type !== 'text/csv') {
            setError(l('PLEASE_UPLOAD_VALID_CSV_FILE'))
            return
        }

        const reader = new FileReader()

        reader.onload = (event) => {
            const csvString = event.target?.result as string

            if (csvString) {
                const {
                    data,
                    error: parsingError,
                } = csvToJson(csvString)

                if (parsingError) {
                    setError(parsingError)
                } else {
                    onLoadData(data, file)
                }
            }
        }
        reader.readAsText(file)
    }, [
        l,
        onLoadData,
        setError,
    ])
}

export default useParseCsvFile
